import { render, staticRenderFns } from "./loc-type-cards.vue?vue&type=template&id=9f8ec46a&scoped=true"
import script from "./loc-type-cards.vue?vue&type=script&lang=js"
export * from "./loc-type-cards.vue?vue&type=script&lang=js"
import style0 from "./loc-type-cards.vue?vue&type=style&index=0&id=9f8ec46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8ec46a",
  null
  
)

export default component.exports